import type { QueryObject } from '../api/httpClient';
import { buildOrderedUrlWithParams } from './urlHelpers';

export type ImageOptions = {
  width?: number,
  height?: number,
  quality?: number,
  format?: string,
  rmode?: string
} & QueryObject;

const DEFAULT_IMAGE_OPTIONS: Partial<ImageOptions> = {
  quality: 80,
  format: 'webp',
  rmode: 'pad'
};

export function getUnitSummaryPlanImageUrl(url?: string): string {
  if (!url) {
    return '';
  }

  return getImageUrl(url, { height: 400 });
}

export function getStyleThumbnailImageUrl(url?: string, width: number = 200): string {
  if (!url) {
    return '';
  }

  return getImageUrl(url, { width });
}

export function getImageUrlWithCustomWidth(url?: string, customWidth?: number): string {
  if (!url) {
    return '';
  }

  return getImageUrl(url, { width: customWidth ?? 500 });
}

function getImageUrl(url: string, options: ImageOptions): string {
  const imageParamOrder: (keyof ImageOptions)[] = ['width', 'height', 'rmode', 'format', 'quality'];
  return buildOrderedUrlWithParams(url, options, imageParamOrder, DEFAULT_IMAGE_OPTIONS);
}
